var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRankIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "23px",
    viewBox: "0 0 17 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "medal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.070588 0 0 0 0 0.415686 0 0 0 0 0.541176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medal",
    transform: "translate(-283.000000, -305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.125000, 305.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,4.45941176 C5.85577778,4.45941176 4.11106667,6.19129412 4.11106667,8.31975 C4.11106667,10.4482059 5.85577778,12.1800882 8,12.1800882 C10.1442222,12.1800882 11.8889333,10.4482059 11.8889333,8.31975 C11.8889333,6.19129412 10.1442222,4.45941176 8,4.45941176 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "7.12631111 17.6400441 7.10542222 17.6210735 6.60991111 17.1759706 5.44382222 16.1287059 4.17591111 16.2641471 3.4 16.3466471 3.21604444 16.3665 2.62364444 16.4295882 0.758044444 20.3649265 3.64711111 20.4028676 5.51711111 22.5882353 7.64315556 18.1041176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "13.3763556 16.4295882 12.7839556 16.3665 12.6 16.3470882 11.8240889 16.2641471 10.5561778 16.1287059 9.39008889 17.1759706 8.89457778 17.6210735 8.87368889 17.6400441 8.35684444 18.1041176 10.4828889 22.5882353 12.3528889 20.4028676 15.2419556 20.3649265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8108889,8.31979412 L15.9712889,5.74888235 L13.5101333,4.34602941 L12.9266222,1.58894118 L10.1046667,1.88977941 L8,0 L5.89533333,1.88982353 L3.07337778,1.58898529 L2.48986667,4.34602941 L0.0287555556,5.74883824 L1.18906667,8.31975 L0.0287555556,10.8906618 L2.48986667,12.2934706 L3.07337778,15.0505588 L3.28848889,15.0276176 L4.06484444,14.9446765 L4.84075556,14.8621765 L5.04875556,14.8401176 L5.0492,14.8401176 L5.89533333,14.7496765 L6.53173333,15.3209559 L7.20324444,15.924 L7.41257778,16.1119412 L7.72008889,16.3880735 L8.00004444,16.6395 L8.28,16.3880735 L8.58751111,16.1119412 L8.79684444,15.924 L9.31902222,15.4555147 L9.31946667,15.4550735 L10.1047111,14.7497206 L11.4761333,14.89575 L11.4765778,14.89575 L11.6161333,14.91075 L11.9352,14.9447206 L11.9356444,14.9447206 L12.7115556,15.0276618 L12.9266667,15.0506029 L13.5101778,12.2935147 L15.9712889,10.8907059 L14.8108889,8.31979412 Z M8,13.5035294 C5.12071111,13.5035294 2.77782222,11.1783088 2.77782222,8.31975 C2.77782222,5.46163235 5.12071111,3.13597059 8,3.13597059 C10.8792889,3.13597059 13.2221778,5.46163235 13.2221778,8.31975 C13.2221778,11.1783088 10.8792889,13.5035294 8,13.5035294 Z",
    id: "Shape",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankIcon);
export default __webpack_public_path__ + "static/media/RankIcon.69564abbdcd42cdd17dbca9d7914be39.svg";
export { ForwardRef as ReactComponent };